var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clear-wrapper uk-text-right uk-margin-bottom"},[_c('span',[_c('a',[_vm._v("clear "),_vm._t("default"),_c('ClearIcon',{ref:"clear"})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }